// @team User Accounts & Identities
import flow from 'lodash/flow';
import { NextPage, NextPageContext } from 'next';

import Signup from '../../features/Signup/pages';
import { withApolloContext } from '../../utils/apollo';
import {
  getReceivedGiftCardCookie,
  getReceivedSubsGiftCardCookie,
} from '../../utils/cookies';
import CookieName from '../../utils/cookies/cookieName';
import isBoxycharmSubdomain from '../../utils/isBoxycharmSubdomain';

const SignupWrapper: NextPage<{
  isBoxycharmSubdomain?: boolean;
  giftCardId?: string;
}> = ({ isBoxycharmSubdomain, giftCardId }) => {
  return (
    <Signup
      isBoxycharmSubdomain={isBoxycharmSubdomain}
      giftCardId={giftCardId}
    />
  );
};

SignupWrapper.getInitialProps = async (ctx: NextPageContext) => ({
  isBoxycharmSubdomain: isBoxycharmSubdomain(ctx),
  giftCardId:
    getReceivedGiftCardCookie(ctx) || getReceivedSubsGiftCardCookie(ctx),
});

const Cmp = flow(withApolloContext({ ssr: true }))(SignupWrapper);

Cmp.displayName = 'Signup';

export default Cmp;
